import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { RAW_DATE_FORMAT } from '@/common/constants';
import { Pagination } from '@/common/types';
import { API_URL, IServiceDto } from '@/dtos';

import { Service } from './useServices.query';
export const QUERY_KEY = 'GET_DEDUCTIBLES_SERVICES';

const SERVICE_TYPE_MANUAL_CLAIM = 'MANUAL_CLAIM';

export default (employeeId?: string, serviceDate?: string) => {
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, employeeId, serviceDate],
    () =>
      api.get<Pagination<IServiceDto>>(API_URL.DEDUCTIBLES_SERVICES, {
        params: {
          employee_id: employeeId,
          service_on: dayjs(serviceDate).format(RAW_DATE_FORMAT),
          service_type: SERVICE_TYPE_MANUAL_CLAIM,
          page: 0,
          size: 1000,
        },
      }),
    {
      retry: 0,
      enabled: !!employeeId && !!serviceDate,
    }
  );

  const options = useMemo(() => {
    const list = data?.data?.content;

    const currentOptions: Service[] =
      list?.map((item) => ({
        id: `${item.id}`,
        key: `${item.id}`,
        name: item.name || '',
        categoryType: item?.category_type || '',
      })) || [];
    return currentOptions;
  }, [data?.data?.content]);

  const isOptionsExists = useMemo(() => {
    return !!data?.data?.totalElements;
  }, [data?.data?.totalElements]);
  return {
    isOptionsExists,
    options,
    isLoading,
    isSuccess,
  };
};
